<template>
  <div class="batch-enroll-student-type" v-loading="committing" element-loading-text="保存中...">
    <el-checkbox-group v-model="checkStudentTypes">
      <el-checkbox v-for="item in studentTypeList" :label="item.code" :key="item.code">{{item.name}}</el-checkbox>
    </el-checkbox-group>
    <el-button type="primary" @click="saveData">保存</el-button>
  </div>
</template>

<script>
export default {
  name: 'BatchEnrollStudentType',
  props: {
    rowData: Object
  },
  data () {
    return {
      committing: false,
      studentTypeList: [
        {
          name: 'MBA',
          code: 'MBA'
        },
        {
          name: 'EMBA',
          code: 'EMBA'
        }
      ],
      checkStudentTypes: []
    }
  },
  methods: {
    saveData () {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/enrolling/batch/setEnrollStudentTypes',
        method: 'post',
        data: this.$qs.stringify({
          batchId: this.rowData.id,
          studentTypes: this.checkStudentTypes.join(',')
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success('保存成功')
              break
            }
            default:
              this.$message.error(response.data['message'] || '保存失败')
          }
        }
      }).finally(() => {
        this.committing = false
      })
    }
  },
  mounted () {
    this.checkStudentTypes = this.rowData.enrollStudentTypes ? this.rowData.enrollStudentTypes.split(',') : []
  }
}
</script>

<style lang="scss">
.batch-enroll-student-type {
  padding: 10px;
  text-align: center;
  .el-button {
    margin-top: 20px;
  }
}
</style>
